import confetti from "canvas-confetti"

const COLORS = ["#22c55e", "#3b82f6", "#f59e0b", "#ec4899", "#8b5cf6", "#06b6d4", "#f43f5e"]

export function fireTrackCompletionConfetti() {
  // Burst 1 — big center explosion
  void confetti({
    particleCount: 120,
    spread: 80,
    origin: { y: 0.6 },
    colors: COLORS,
    startVelocity: 45,
  })

  // Burst 2 — wider spray
  setTimeout(() => {
    void confetti({
      particleCount: 80,
      spread: 140,
      origin: { y: 0.55 },
      colors: COLORS,
      startVelocity: 35,
    })
  }, 200)

  // Burst 3 — from left side
  setTimeout(() => {
    void confetti({
      particleCount: 60,
      angle: 60,
      spread: 60,
      origin: { x: 0, y: 0.65 },
      colors: COLORS,
      startVelocity: 50,
    })
  }, 400)

  // Burst 4 — from right side
  setTimeout(() => {
    void confetti({
      particleCount: 60,
      angle: 120,
      spread: 60,
      origin: { x: 1, y: 0.65 },
      colors: COLORS,
      startVelocity: 50,
    })
  }, 500)

  // Burst 5 — stars from top
  setTimeout(() => {
    void confetti({
      particleCount: 40,
      spread: 160,
      origin: { y: 0.1 },
      colors: COLORS,
      gravity: 1.2,
      shapes: ["star"],
      scalar: 1.4,
    })
  }, 700)

  // Burst 6 — circles from top
  setTimeout(() => {
    void confetti({
      particleCount: 50,
      spread: 100,
      origin: { y: 0.2, x: 0.5 },
      colors: COLORS,
      shapes: ["circle"],
      scalar: 1.2,
    })
  }, 900)

  // Burst 7 — grand finale from both sides
  setTimeout(() => {
    void confetti({
      particleCount: 70,
      angle: 55,
      spread: 70,
      origin: { x: 0, y: 0.7 },
      colors: COLORS,
      startVelocity: 55,
    })
    void confetti({
      particleCount: 70,
      angle: 125,
      spread: 70,
      origin: { x: 1, y: 0.7 },
      colors: COLORS,
      startVelocity: 55,
    })
  }, 1100)
}
